
<template lang="pug">
  .navbar__cart
    icon-button(
      :icon="getCartIcon"
      width="26px"
      height="21px"
      label="Open Cart"
      @mouseover.native="cartHighlighted = true"
      @mouseleave.native="cartHighlighted = false"
      @click="$store.dispatch('cart/openSidecart')"
    )
    span.navbar__cart__quantity {{ numCartItems }}
</template>

<script>
  import { mapState } from 'vuex';

  import IconButton from 'scripts/components/buttons/IconButton.vue';

  export default {
    name: 'NavbarCart',
    components: { IconButton },
    data() {
      return {
        cartHighlighted: false,
      };
    },
    computed: {
      ...mapState({
        checkout: state => state.cart.checkout,
      }),
      numCartItems () {
        return this.checkout.item_count || 0;
      },
      getCartIcon () {
        return this.cartHighlighted ? 'highlighted-cart' : 'cart';
      }
    },
  };
</script>


<style lang="scss">
  .sidecart__header-icon,
  .navbar__cart {
    position: relative;
    height: 32px;
    width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;

    &__quantity {
      position: absolute;
      display: block;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -54%);
      padding-left: 6px;
      font-size: rem(14);
      line-height: 1.2;
      font-weight: 700;
      font-family: $font-acumin-pro;
      pointer-events: none;
      color: $color-indigo;
      transition: 0.3s ease all;
    }
  }
</style>
